import $ from 'jquery';
import $script from 'scriptjs';

/**
 * @description Loads the Alpinejs library
 * @returns {Promise<Alpine>}
 */
export function loadAlpineAsync() {
  return import(
    /* webpackChunkName: "alpine" */
    'alpinejs'
  ).then((m) => m.default);
}

/**
 * @description Loads the jquery.matchHeight plugin
 */
export function loadMatchHeightAsync() {
  return new Promise((resolve, _) => {
    $(function () {
      $script.get(
        'https://cdnjs.cloudflare.com/ajax/libs/jquery.matchHeight/0.7.2/jquery.matchHeight-min.js',
        () => resolve(true),
      );
    });
  });
}

/**
 * @description Loads the Ekko Lightbox plugin
 */
export function loadEkkoLightboxAsync() {
  return new Promise((resolve, _) => {
    $(function () {
      $script.get(
        'https://cdnjs.cloudflare.com/ajax/libs/ekko-lightbox/5.3.0/ekko-lightbox.min.js',
        () => resolve(true),
      );
    });
  });
}

/**
 * @description Loads the Google Maps library
 * @param {string} apiKey
 * @returns {Promise<google>}
 */
export function loadGoogleMapsAsync(apiKey) {
  return new Promise((resolve, _) => {
    const callbackFunctionName = 'googleMapsLoaded';

    window[callbackFunctionName] = () => {
      resolve(window.google);
    };

    $script.get(
      `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=${callbackFunctionName}&libraries=&v=weekly`,
      () => {},
    );
  });
}
